import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { getDivider, getEndDate, getStartDate  } from '../utils';
import { setUcfirst } from '../../../handlers/helpers';

const PreviewVolunteer = ({ items }) => {

  return (
    <Box className="contentBox">
      {Object.values(items.map((item) => {
            const address = item.location === 'inperson' ? item.city + getDivider(item.city, item.state, ', ') + item.state : 'Remote';
            return (

              <Text className="subSections">
                {/*Text is necessary above to make _last work*/}
                <Box className="subSectionsInterior">
                  <Box className="subSection">
                    <Box className="name">{item.organization}</Box>
                      <Box className="jobTitle">{item.position}</Box>
                  </Box>
                  <Box>

                    <Box className='address'>
                      <Box className="alignRight">{setUcfirst(address)}</Box>
                    </Box>
                    <Box className='dates'>
                      <Text className="startDate">{getStartDate(item)}</Text>
                      <Text className="endDate">{getEndDate(item)}</Text>
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Text>{item.populations}</Text>
                </Box>
              </Text>
            );
          },
        ),
      )
      }
    </Box>
  );
};
export default PreviewVolunteer;
